import { createMuiTheme } from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";

export const darkTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#a8bb43",
      dark: "#a8bb43",

      contrastText: "#fff"
    },
    secondary: {
      main: "#a8bb43",
      contrastText: "#fff"
    },
    error: red,
    contrastThreshold: 4,
    tonalOffset: 0.3,
    text: {
      primary: "#fff",
      secondary: "#fff"
    }
  },
  overrides: {
    MuiInputBase: {
      root: {
        color: "#222",
        background: "white"
      }
    },
    MuiFormLabel: {
      root: {
        color: "#fff"
      }
    },
    MuiTypography: {
      colorTextPrimary: {
        color: "#fff"
      },
      subtitle2: {
        color: "#fff"
      }
    },
    MuiSvgIcon: {
      root: {
        color: "#fff"
      }
    },
    MuiTabs: {
      root: {
        minWidth: 160,
        "480": {
          width: "50%",
          minHeight: 30,
          fontSize: "12px",
          lineHeight: 1.5
        }
      }
    },
    MuiTab: {
      root: {
        "&$selected": {
          background: "#4f4f4f"
        }
      },
      wrapper: {
        color: "white"
      }
    },
    MuiMenuItem: {
      root: {
        color: "#222!important"
      }
    },
    MuiInputLabel: {
      root: {
        color: "#fff",
        zIndex: 2,
        $focused: {
          color: "#a8bb43"
        }
      }
    },
    MuiFormControlLabel: {
      label: {
        color: "#fff"
      }
    },
    MuiChip: {
      root: {
        borderRadius: 5
      }
    },
  }
});

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#a8bb43",
      dark: "#a8bb43"
    },
    secondary: {
      main: "#a8bb43",
      contrastText: "#fff"
    },
    error: red,
    contrastThreshold: 4,
    tonalOffset: 0.3,
    text: {
      primary: "#222",
      secondary: "#333"
    }
  },
  typography: {
    useNextVariants: true
  },
  overrides: {
    MuiInput: {
      input: {
        color: "#222"
      }
    },
    MuiChip: {
      root: {
        borderRadius: 5
      }
    },
    MuiTypography: {
      root: {
        color: "#222"
      }
    },
    MuiButton: {
      root: {
        "&$disabled": {
          color: "#aaa !important"
        }
      },
      contained: {
        color: "#fff !important"
      }
    },
    MuiInputLabel: {
      root: {
        color: "#777"
      }
    }
  }
});

export default theme;
